import { render, staticRenderFns } from "./CustomDatepickerRangeTheme2.vue?vue&type=template&id=2c8e8b1b&scoped=true"
import script from "./CustomDatepickerRangeTheme2.vue?vue&type=script&lang=js"
export * from "./CustomDatepickerRangeTheme2.vue?vue&type=script&lang=js"
import style0 from "./CustomDatepickerRangeTheme2.vue?vue&type=style&index=0&id=2c8e8b1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8e8b1b",
  null
  
)

export default component.exports